(function () {
  'use strict';

  class TestimonialHighlights {
    constructor(el) {
      this.el = el;
      this.slides = Array.from(el.querySelectorAll('.testimonial-highlights__slide'));
      this.dots   = Array.from(el.querySelectorAll('.testimonial-highlights__dot'));
      this.total  = this.slides.length;
      this.current = 0;
      this.speed  = parseInt(el.dataset.transitionSpeed, 10) || 5000;
      this.timer  = null;

      if (this.total <= 1) return;

      // Dot click navigation
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.goTo(i);
          this.restart();
        });
      });

      // Pause on hover / focus inside
      el.addEventListener('mouseenter', () => this.pause());
      el.addEventListener('mouseleave', () => this.start());
      el.addEventListener('focusin',    () => this.pause());
      el.addEventListener('focusout',   (e) => {
        if (!el.contains(e.relatedTarget)) this.start();
      });

      this.start();
    }

    goTo(index) {
      const prev = this.current;
      this.current = ((index % this.total) + this.total) % this.total;

      // Deactivate previous
      this.slides[prev].classList.remove('is-active');
      this.slides[prev].setAttribute('aria-hidden', 'true');
      if (this.dots[prev]) {
        this.dots[prev].classList.remove('is-active');
        this.dots[prev].setAttribute('aria-selected', 'false');
      }

      // Activate next
      this.slides[this.current].classList.add('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'false');
      if (this.dots[this.current]) {
        this.dots[this.current].classList.add('is-active');
        this.dots[this.current].setAttribute('aria-selected', 'true');
      }
    }

    start() {
      if (this.timer) return;
      this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
    }

    pause() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.pause();
      this.start();
    }
  }

  function init() {
    document.querySelectorAll('.testimonial-highlights[data-transition-speed]').forEach((el) => {
      if (!el.dataset.thInitialized) {
        el.dataset.thInitialized = 'true';
        new TestimonialHighlights(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
